import type { ReactNode } from 'react';
import { Card, Icon } from '@/ds';

/**
 * Пустое состояние: объяснение и следующий шаг, а не пустой экран
 * (docs/08-screens.md).
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon: string;
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <Card padding="lg" style={{ maxWidth: 620 }}>
      <span
        style={{
          width: 36,
          height: 36,
          borderRadius: 'var(--radius-md)',
          background: 'var(--surface-brand-soft)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon name={icon} size={20} color="var(--burgundy-700)" />
      </span>

      <div
        style={{
          marginTop: 'var(--space-5)',
          font: '500 18px var(--font-display)',
          letterSpacing: 'var(--ls-heading)',
          color: 'var(--text-strong)',
        }}
      >
        {title}
      </div>

      <p
        style={{
          marginTop: 'var(--space-3)',
          font: '400 14px/1.6 var(--font-text)',
          color: 'var(--text-muted)',
          maxWidth: 460,
        }}
      >
        {description}
      </p>

      {action ? <div style={{ marginTop: 'var(--space-6)' }}>{action}</div> : null}
    </Card>
  );
}
